(function () {
  window.WorkshopProductPrintLoaded = true;

  document.addEventListener("click", function (event) {
    const button = event.target.closest('[data-action="print-product-sheet"]');
    if (!button) return;

    event.preventDefault();

    const productId = button.dataset.productPrintId;
    const dataElement = document.getElementById(`ProductPrintData-${productId}`);
    let productData = getFallbackProductData();

    if (dataElement) {
      try {
        productData = Object.assign(productData, JSON.parse(dataElement.textContent));
      } catch (error) {
        console.warn("Dati stampa prodotto non leggibili, uso i dati presenti in pagina.", error);
      }
    }

    productData.price = getCurrentProductPrice() || productData.price;
    productData.sku = getCurrentProductSku() || productData.sku;
    productData.variant = getCurrentVariantTitle() || productData.variant;
    productData.logoUrl = productData.logoUrl || button.dataset.logoUrl || "";
    productData.descriptionHtml = getCurrentProductDescription() || productData.descriptionHtml;

    if (!productData.title) {
      alert("Non riesco a leggere i dati prodotto per la stampa. Ricarica la pagina e riprova.");
      return;
    }

    openProductPrintWindow(productData);
  });

  function openProductPrintWindow(productData) {
    const printWindow = window.open("", "_blank", "width=980,height=1200");

    if (!printWindow) {
      alert("Consenti i popup per stampare la scheda prodotto.");
      return;
    }

    printWindow.document.open();
    printWindow.document.write(buildPrintHtml(productData));
    printWindow.document.close();

    setTimeout(function () {
      printWindow.focus();
      printWindow.print();
    }, 1200);
  }

  function buildPrintHtml(productData) {
    const imagesMarkup = productData.images && productData.images.length > 0
      ? productData.images.map(imageUrl => `<img src="${escapeAttribute(imageUrl)}" alt="">`).join("")
      : "";
    const sku = productData.sku ? `<span>Codice: ${escapeHtml(productData.sku)}</span>` : "";
    const vendor = productData.vendor ? `<span>Brand: ${escapeHtml(productData.vendor)}</span>` : "";
    const variant = productData.variant ? `<span>Variante: ${escapeHtml(productData.variant)}</span>` : "";

    return `<!doctype html>
<html lang="it">
  <head>
    <meta charset="utf-8">
    <title>${escapeHtml(productData.title)} - Scheda prodotto</title>
    <style>
      * { box-sizing: border-box; }
      body {
        margin: 0;
        color: #1f1f1f;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
        line-height: 1.45;
      }
      .product-sheet {
        width: 190mm;
        margin: 0 auto;
        padding: 10mm 0;
      }
      .product-sheet__header {
        padding-bottom: 7mm;
        border-bottom: 1px solid #d9d9d9;
      }
      .product-sheet__logo {
        width: 112mm;
        max-height: 52mm;
        object-fit: contain;
        object-position: left top;
      }
      .product-sheet__meta {
        margin-top: 4mm;
        color: #686868;
        font-size: 10px;
        text-align: left;
      }
      .product-sheet__gallery {
        display: grid;
        grid-template-columns: 1.35fr 1fr 1fr;
        gap: 4mm;
        margin: 7mm 0;
        break-inside: avoid;
      }
      .product-sheet__gallery img {
        width: 100%;
        aspect-ratio: 1 / 1;
        object-fit: contain;
        border: 1px solid #e4e4e4;
        background: #fff;
      }
      .product-sheet__gallery img:first-child {
        grid-row: span 2;
      }
      .product-sheet__summary {
        margin: 0 0 7mm;
        padding: 5mm;
        border: 1px solid #e1e1e1;
        border-left: 4px solid #cb1836;
        border-bottom: 1px solid #d9d9d9;
        break-inside: avoid;
      }
      h1 {
        margin: 0 0 3mm;
        font-size: 22px;
        line-height: 1.15;
      }
      .product-sheet__reference {
        display: flex;
        flex-wrap: wrap;
        gap: 2mm 7mm;
        color: #555;
        font-size: 11px;
      }
      .product-sheet__price-label {
        display: inline-block;
        margin: 3mm 4mm 0 0;
        color: #666;
        font-size: 11px;
        text-transform: uppercase;
      }
      .product-sheet__price {
        display: inline-block;
        margin-top: 3mm;
        color: #cb1836;
        font-size: 24px;
        font-weight: 700;
      }
      .product-sheet__section-title {
        margin: 0 0 3mm;
        padding-bottom: 2mm;
        border-bottom: 1px solid #d9d9d9;
        font-size: 15px;
      }
      .product-sheet__description {
        font-size: 11px;
      }
      .product-sheet__description p {
        margin: 0 0 3mm;
      }
      .product-sheet__description ul,
      .product-sheet__description ol {
        margin-top: 0;
        padding-left: 6mm;
      }
      .product-sheet__description img {
        display: block;
        max-width: 100%;
        height: auto;
        margin: 4mm auto;
        break-inside: avoid;
      }
      .product-sheet__description iframe,
      .product-sheet__description video,
      .product-sheet__description script,
      .product-sheet__description style {
        display: none !important;
      }
      .product-sheet__description table {
        width: 100%;
        border-collapse: collapse;
        page-break-inside: avoid;
      }
      .product-sheet__description td,
      .product-sheet__description th {
        padding: 2mm;
        border: 1px solid #dedede;
        vertical-align: top;
      }
      .product-sheet__footer {
        margin-top: 8mm;
        padding-top: 3mm;
        border-top: 1px solid #d9d9d9;
        color: #777;
        font-size: 10px;
      }
      a { color: #cb1836; text-decoration: none; }
      @page { size: A4; margin: 10mm; }
      @media print {
        .product-sheet { width: auto; padding: 0; }
      }
    </style>
  </head>
  <body>
    <main class="product-sheet">
      <header class="product-sheet__header">
        <img class="product-sheet__logo" src="${escapeAttribute(productData.logoUrl)}" alt="Workshop Italy">
        <div class="product-sheet__meta">
          Scheda prodotto generata il ${escapeHtml(new Date().toLocaleDateString("it-IT"))}<br>
          <a href="${escapeAttribute(productData.url)}">${escapeHtml(productData.url)}</a>
        </div>
      </header>

      <section class="product-sheet__gallery">${imagesMarkup}</section>

      <section class="product-sheet__summary">
        <h1>${escapeHtml(productData.title)}</h1>
        <div>
          <span class="product-sheet__price-label">Prezzo</span>
          <span class="product-sheet__price">${escapeHtml(productData.price)}</span>
        </div>
        <div class="product-sheet__reference">${vendor}${sku}${variant}</div>
      </section>

      <section>
        <h2 class="product-sheet__section-title">Descrizione</h2>
        <div class="product-sheet__description">${productData.descriptionHtml || ""}</div>
      </section>

      <footer class="product-sheet__footer">
        Documento generato da workshopitaly.net. Prezzi e disponibilita possono variare.
      </footer>
    </main>
  </body>
</html>`;
  }

  function getCurrentProductPrice() {
    const priceNode = document.querySelector(".product-form__info-content .price:not(.price--compare), .price-list .price:not(.price--compare)");
    return priceNode ? cleanPriceText(priceNode.textContent) : "";
  }

  function cleanPriceText(priceText) {
    return String(priceText || "")
      .replace(/prezzo\s+scontato/gi, "")
      .replace(/prezzo\s+di\s+vendita/gi, "")
      .replace(/prezzo\s+normale/gi, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function getCurrentProductSku() {
    const skuNode = document.querySelector(".product-meta__sku-number");
    return skuNode ? skuNode.textContent.trim() : "";
  }

  function getCurrentVariantTitle() {
    const selectedOption = document.querySelector(".product-form select[name='id'] option:checked");
    const checkedRadio = document.querySelector(".product-form input[name='id']:checked");
    const variantTitle = selectedOption ? selectedOption.textContent : "";

    if (variantTitle && !variantTitle.toLowerCase().includes("default title")) {
      return variantTitle.replace(/\s+-\s+.+$/, "").trim();
    }

    if (checkedRadio && checkedRadio.dataset && checkedRadio.dataset.sku) {
      return checkedRadio.dataset.sku.trim();
    }

    return "";
  }

  function getCurrentProductDescription() {
    const descriptionNodes = Array.from(document.querySelectorAll(".product-block-list__item--description .rte"));

    if (descriptionNodes.length === 0) return "";

    return descriptionNodes.map(descriptionNode => {
      const clone = descriptionNode.cloneNode(true);
      const originalNodes = Array.from(descriptionNode.querySelectorAll("*"));
      const clonedNodes = Array.from(clone.querySelectorAll("*"));

      clone.querySelectorAll("script, style, iframe, video").forEach(node => node.remove());
      clonedNodes.forEach((node, index) => {
        const originalNode = originalNodes[index];

        if (!originalNode || !isElementVisible(originalNode)) {
          node.remove();
        }
      });

      return clone.innerHTML.trim();
    }).filter(Boolean).join("");
  }

  function isElementVisible(element) {
    if (!element || element.hidden || element.getAttribute("aria-hidden") === "true") return false;

    const style = window.getComputedStyle(element);
    if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0") return false;

    const hiddenParent = element.closest(".hidden, [hidden]");
    return !hiddenParent;
  }

  function getFallbackProductData() {
    const titleNode = document.querySelector(".product-meta__title");
    const vendorNode = document.querySelector(".product-meta__vendor");
    const images = Array.from(document.querySelectorAll(".product-gallery img, .product-gallery__carousel img, .product-gallery__thumbnail img"))
      .map(image => image.currentSrc || image.src)
      .filter(Boolean)
      .filter((imageUrl, index, list) => list.indexOf(imageUrl) === index)
      .slice(0, 4);

    return {
      title: titleNode ? titleNode.textContent.trim() : document.title,
      vendor: vendorNode ? vendorNode.textContent.trim() : "",
      sku: getCurrentProductSku(),
      variant: getCurrentVariantTitle(),
      price: getCurrentProductPrice(),
      url: window.location.href,
      logoUrl: "",
      descriptionHtml: getCurrentProductDescription(),
      images: images
    };
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (character) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[character];
    });
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, "&#096;");
  }
})();
